<template lang="pug">
v-dialog(
  style="z-index:3000"
  v-model="draggableModalShow"
  persistent
  :width="draggableModalWidth"
  :max-height="draggableModalHeight"
  hide-overlay)
  v-card(
    ref="dialog"
    class="pa-0"
    :width="draggableModalWidth"
    :style="{\
      position: 'fixed',\
      top: `${position.top}px`,\
      left: `${position.left}px`,\
      cursor: dragging ? 'grabbing' : 'grab',\
      zIndex: 1500000\
    }"
    @mousedown="startDrag")
    //- v-card-title(class="headline" color="red") Modal Draggable
    v-app-bar(dark color="pink" dense)
      v-toolbar-title(:title="draggableModalTitle") {{ draggableModalTitle }}

      v-spacer

      v-btn(icon @click="draggableModalShow = false")
        v-icon mdi-close

    v-card-text(class="px-1 pb-1")
      component(
        v-if="draggableModalComponent !== ''"
        class="my-2 px-2"
        v-bind:is="draggableModalComponent"
        v-bind="draggableModalProperties")

    //- v-card-actions
      v-btn(text @click="draggableModalShow = false") Cerrar
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import VectorLayerPicker from '@/components/geos/VectorLayerPicker.vue';

export default {
  name: 'DraggableDialog',

  components: {
    VectorLayerPicker,
  },

  props: {
    // width: {
    //   type: String,
    //   default: '400'
    // }
  },

  data() {
    return {
      visible: this.value,
      dragging: false,
      position: {
        top: 100,
        left: 100,
      },
      offset: { x: 0, y: 0 },
    };
  },

  computed: {
    ...mapState('ui', [
      'draggableModalTitle',
      'draggableModalComponent',
      'draggableModalProperties',
      'draggableModalWidth',
      'draggableModalHeight',
    ]),
    draggableModalShow: {
      get() {
        return this.$store.state.ui.draggableModalShow;
      },
      set(value) {
        return this.$store.commit('ui/CHANGE_VALUE', {
          varName: 'draggableModalShow',
          value
        });
      }
    }
  },

  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit('input', val);
    },
    draggableModalShow: {
      handler(val) {
        if (val === false) {
          if (this.draggableModalComponent === 'VectorLayerPicker') {
            this.filesChangeValue({
              value: [],
              varName: 'fileList'
            });
            this.filesChangeValue({
              value: false,
              varName: 'showFilesPreview'
            });
          }
          if (this.draggableModalComponent === 'ActionLogger') {
            this.uiChangeValue({
              value: null,
              varName: 'wsActionMessage'
            });
            this.uiChangeValue({
              value: [],
              varName: 'wsActionLogger'
            });
            this.uiChangeValue({
              value: '',
              varName: 'wsError'
            });
          }
        }
      }
    }
  },

  methods: {
    ...mapMutations('files', { filesChangeValue: 'CHANGE_VALUE' }),
    ...mapMutations('ui', { uiChangeValue: 'CHANGE_VALUE' }),
    startDrag(e) {
      // Inicia arrastre solo si se hace click en la tarjeta
      this.dragging = true;

      this.offset.x = e.clientX - this.position.left;
      this.offset.y = e.clientY - this.position.top;

      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },

    onDrag(e) {
      if (!this.dragging) return;

      const { dialog } = this.$refs;
      const dialogWidth = dialog.offsetWidth;
      const dialogHeight = dialog.offsetHeight;

      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      let newLeft = e.clientX - this.offset.x;
      let newTop = e.clientY - this.offset.y;

      // ✅ LIMITES HORIZONTALES
      if (newLeft < 0) newLeft = 0;
      if (newLeft + dialogWidth > screenWidth) {
        newLeft = screenWidth - dialogWidth;
      }

      // ✅ LIMITES VERTICALES
      if (newTop < 0) newTop = 0;
      if (newTop + dialogHeight > screenHeight) {
        newTop = screenHeight - dialogHeight;
      }

      this.position.left = newLeft;
      this.position.top = newTop;
    },

    stopDrag() {
      this.dragging = false;

      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },

  },
};
</script>

<style scoped>
/* Opcional: mejora UX del draggable */
.v-card {
  transition: none !important;
}
</style>
